
export default {
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    isEmpty() {
      return !this.items.length;
    },
  },
};
